import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function WalletBannerSkeleton() {
    return (
        <section className="wallet-section section-bg">
            <div className="container wallet-container">
                <div className="row justify-content-center">
                    {/* Text Column */}
                    <div className="col-lg-6 col-md-7">
                        <div className="wallet-content">
                            <Skeleton height={36} width="80%" borderRadius={10} className="mb-2" />
                            <Skeleton height={17} width={312} borderRadius={8} className="mb-3" />
                            <Skeleton height={60} borderRadius={10} className="mb-3" />
                            <Skeleton height={45} width={160} borderRadius={8} />
                        </div>
                    </div>

                    {/* Image Column */}
                    <div className="col-lg-6 col-md-5 col-sm-9">
                        <div className="wallet-thumb">
                            <Skeleton height={379} width={669} borderRadius={20} />
                        </div>
                    </div>
                </div>

                {/* Subtitle Row */}
                <div className="row mt-4">
                    <div className="col-lg-7 col-md-9">
                        <div className="wallet-content two">
                            <Skeleton height={30} width="60%" borderRadius={10} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
